'use client';

import dynamic from 'next/dynamic';

const FaqPartDynamic = dynamic(() => import('./FaqPart'), { ssr: false });

export default function ClientFaqPartWrapper(props: { groupInfo: any; isWeb?: boolean }) {
  return <FaqPartDynamic {...props} />;
}
